//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

/* jshint jquery: true */

(function() {
  angular.module('curalate')
        /*
         * toggle-option is a sub-component of the 'toggle' component and represents a single option.
         *
         * @attr value      The value of the option that is sent in the callback function of the parent scope.
         * @attr name       (Optional) The user-facing name of the option
         * @attr icon       (Optional) One or more classes that represent an icon that should be displayed.
         * @attr disabled   (Optional) Value to determine if an option is disabled.
         * @attr tt         (Optional) Text for a tooltip.
         */
        .directive('toggleOption', () => ({
          restrict: 'E',
          scope: {
            value: '@',
            name: '@',
            icon: '@',
            svg: '@',
            disabled: '=',
            tt: '@',
            class: '@',
          },
          require: '^toggle',
          link(scope, element, attrs, toggle) {
            const option = {
              name: scope.name,
              value: scope.value,
              svg: scope.svg,
              icon: scope.icon,
              disabled: scope.disabled,
              tt: scope.tt,
              class: scope.class || '',
            };

                    // Report option to parent toggle
            toggle.registerOption(option);

            scope.$watch('disabled', (disabledValue) => {
              option.disabled = disabledValue;
              toggle.updateOption(option);
            });
          },
        }));
})();
